<div class="container-box header-div-container" id="main-container-box" *ngIf="!hideNavBar">
  <div class="slant header-div-slant-container" id="slan-div-container">
    <div *ngIf="false" class="header-div-text-container" id="header-text-container">
      <span class="header-text-content" id="header-text-span">
        Leica Remote Services Application - T&C agreement
      </span>
    </div>
    <div class="main-header-parent-container">
      <div class="nav-buttons-container" id="nav-buttons-container-main">
        <div class="devices-navbar-button nav-buttons" id="devices-nav-button" (click)="navigateToDeviceDetails()"
          [ngClass]="deviceBackgroundStyle ? 'backGroundStyle' : ''">
          <span class="module-name" id="devices-nav-span">{{"Assets" | transloco}}</span>
          <img src="../../../assets/icons/icon-assets.svg" id="devices-img" class="module-icon" alt="icon" />
        </div>
        <div *ngIf="showConfigurationsTab" class="configuration-navbar-button  nav-buttons" id="config-nav-button"
          [ngClass]="configBackgroundStyle ? 'backGroundStyle' : ''">
          <span class="module-name" id="config-nav-span">{{"ConfigurationTabText" | transloco}}</span>
          <img src="../../../assets/icons/icon-cog.svg" id="config-img" class="module-icon" alt="icon" />
          <div class="user-management-link span-hover-effect" (click)="navigateToUserManagement()">{{"UserManagementTabText" | transloco}}
          </div>
        </div>
        <div class="software-navbar-button  nav-buttons"  id="software-nav-button" (click)="navigateToPatchManangement()"
          [ngClass]="patchBackgroundStyle ? 'backGroundStyle' : ''">
          <span class="module-name" id="software-nav-span">{{"softwareTabText" | transloco}}</span>
          <div class="icon-wrapper">
            <img src="../../../assets/icons/software-updates.svg" class="module-icon" alt="icon" />
          </div>
        </div>



      </div>
      <div class="right-container">
        <div class="user-and-logo-container">
          <div *ngIf="showCautionBanner">
            <div tooltip [tooltipContent]="'cautionAmberContent'" [tooltipDynamicContent]="tooltipDynamicContentValue" class="user-navbar-amber-button" style="flex-direction: row;" id="user-nav-amber-button">
             
              <img height="20" width="20" src="../../../assets/icons/icon-caution.svg" id="user-img" alt="icon"/>
            </div>
  
          </div>
            <div class="user-wrapper"  id="user-nav-button"
              (click)="toggleLogout()" clickOutside
              (clickOutside)="closeLogoutWindow()">
              <div class="container-div">
                <span id="username-nav-span" >{{ username }}</span>
                <!-- <span id="userRole-nav-span">{{ userRole }}</span> -->
              <img [src]="logoutImgSrc"  class="userIcon" id="user-img" alt="icon" />
              <div *ngIf="isLogoutClicked" [ngClass]="isLogoutClicked ? 'logout': ''">
                <span class="triangle-top"></span>                        
                <span class="span-hover-effect" (click)="setServiceKey()">{{"setServiceKeyText" | transloco}}</span>
                <span class="span-hover-effect" (click)="initiateLogout()">{{"Logout" | transloco}}</span>
              </div>
            </div>
          </div>
          <div *ngIf="false" class="header-div-text-container" id="agreement-text-container">
            <span class="header-text-content" id="agreement-text-span">
              Leica Remote Services Application - T&C agreement
            </span>
          </div>
        </div>
        <div class="header-image-container" id="leica-logo-container">
          <img id="leica-logo-img" src="../../../assets/icons/leica-logo.svg" alt="leica-logo" />
        </div>
      </div>
     
    </div>
  </div>
 
</div>